module.exports = __webpack_public_path__ + "static/media/kesariphirnee.9f48fd31.jpg";